<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Item') : $t('New Item')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-tabs v-model="tab" background-color="gray" dark right v-else>
            <v-tab key="form">{{ $t("form") }}</v-tab>
            <v-tab key="links">{{ $t("links") }}</v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item key="form">
                <v-card class="px-2">
                  <v-form
                    ref="form"
                    autocomplete="new-password"
                    lazy-validation
                    @submit.prevent="saveItem"
                  >
                    <v-text-field
                      v-model="formValues.code"
                      :label="$t('code')"
                      v-validate="'required'"
                      required
                      data-vv-name="code"
                      :error-messages="errors.collect('code')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.name"
                      label="Name"
                      v-validate="'required'"
                      required
                      data-vv-name="name"
                      :error-messages="errors.collect('name')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.name_it"
                      label="Name IT"
                      v-validate=""
                      required
                      data-vv-name="name_it"
                      :error-messages="errors.collect('name_it')"
                    ></v-text-field>
                    <v-select
                      v-model="formValues.type"
                      :items="types"
                      :label="$t('type')"
                      item-text="name"
                      item-value="id"
                      data-vv-name="type"
                      :error-messages="errors.collect('type')"
                    ></v-select>
                    <v-textarea
                      v-model="formValues.description"
                      :label="$t('description')"
                      v-validate="'required'"
                      required
                      data-vv-name="description"
                      :error-messages="errors.collect('description')"
                    ></v-textarea>
                    <v-text-field
                      v-model="formValues.producer"
                      :label="$t('producer')"
                      v-validate=""
                      data-vv-name="producer"
                      :error-messages="errors.collect('producer')"
                    ></v-text-field>
                    <v-text-field
                      v-model="formValues.producer_url"
                      :label="$t('producer_url')"
                      v-validate=""
                      data-vv-name="producer_url"
                      :error-messages="errors.collect('producer_url')"
                    ></v-text-field>
                    <v-select
                      v-model="formValues.category_id"
                      :items="categories"
                      :label="$t('category')"
                      item-text="name"
                      item-value="id"
                      data-vv-name="category_id"
                      :error-messages="errors.collect('category_id')"
                    ></v-select>
                    <v-text-field
                      v-if="formValues.type == 'glass'"
                      v-model="formValues.ligth_transmission_level"
                      :label="$t('ligth_transmission_level')"
                      v-validate=""
                      data-vv-name="ligth_transmission_level"
                      type="number"
                      :error-messages="
                        errors.collect('ligth_transmission_level')
                      "
                    ></v-text-field>
                    <v-text-field
                      v-if="formValues.type == 'glass'"
                      v-model="formValues.overall_energy_transmission_level"
                      :label="$t('overall_energy_transmission_level')"
                      v-validate=""
                      data-vv-name="overall_energy_transmission_level"
                      type="number"
                      :error-messages="
                        errors.collect('overall_energy_transmission_level')
                      "
                    ></v-text-field>
                    <v-text-field
                      v-if="formValues.type == 'glass'"
                      v-model="formValues.ug_value"
                      :label="$t('ug_value')"
                      v-validate=""
                      data-vv-name="ug_value"
                      type="number"
                      :error-messages="errors.collect('ug_value')"
                    ></v-text-field>
                    <v-select
                      v-if="formValues.type == 'wood'"
                      v-model="formValues.wood_type"
                      :items="[
                        {
                          id: 'softwood',
                          name: $t('softwood')
                        },
                        {
                          id: 'hardwood',
                          name: $t('hardwood')
                        }
                      ]"
                      :label="$t('wood_type')"
                      item-text="name"
                      item-value="id"
                      v-validate="'required'"
                      data-vv-name="wood_type"
                      :error-messages="errors.collect('wood_type')"
                    ></v-select>
                    <v-select
                      v-if="formValues.type == 'threshold'"
                      v-model="formValues.threshold_type"
                      :items="[
                        {
                          id: 'thermally_separated',
                          name: $t('thermally_separated')
                        },
                        {
                          id: 'thermally_not_separated',
                          name: $t('thermally_not_separated')
                        }
                      ]"
                      :label="$t('threshold_type')"
                      item-text="name"
                      item-value="id"
                      required
                      v-validate="'required'"
                      data-vv-name="threshold_type"
                      :error-messages="errors.collect('threshold_type')"
                    ></v-select>
                    <v-select
                      v-model="formValues.suppliers"
                      multiple
                      :items="suppliers"
                      :label="$t('suppliers')"
                      item-text="name"
                      item-value="id"
                      v-validate=""
                      data-vv-name="suppliers"
                      :error-messages="errors.collect('suppliers')"
                    >
                    </v-select>

                    <v-list v-if="sortSuppliers && sortSuppliers.length > 1">
                      <v-subheader>{{ $t("suppliers_order") }}</v-subheader>
                      <v-list-item-group>
                        <draggable
                          v-model="formValues.suppliers"
                          group="people"
                          @start="drag = true"
                          @end="drag = false"
                        >
                          <v-list-item
                            v-for="supplier in sortSuppliers"
                            :key="supplier.name"
                          >
                            <v-list-item-icon>
                              <v-icon></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                supplier.name
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </draggable>
                      </v-list-item-group>
                    </v-list>
                    <v-autocomplete
                      v-model="formValues.subitems"
                      multiple
                      :items="items"
                      :filter="customFilter"
                      :label="$t('subitems')"
                      item-text="name"
                      item-value="id"
                      v-validate=""
                      data-vv-name="subitems"
                      :error-messages="errors.collect('subitems')"
                      :outlined="true"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="removeSubitem(data.item)"
                        >
                          {{ data.item.code }}-{{ data.item.name }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        {{ data.item.code }}-{{ data.item.name }}
                      </template>
                    </v-autocomplete>
                    <v-select
                      v-model="formValues.system1"
                      :items="system1"
                      :label="$t('system1')"
                      item-text="name"
                      item-value="id"
                      data-vv-name="system1"
                      clearable
                      :error-messages="errors.collect('system1')"
                    ></v-select>
                    <h4>{{ $t("certificates") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="certificates"
                      :removeCallback="documentRemoveCallback"
                    ></documentUpload>

                    <h4>{{ $t("images") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="images"
                      :removeCallback="documentRemoveCallback"
                    ></documentUpload>
                    <hr />
                    <h4 class="mt-3">{{ $t("Ausschreibungstext DE") }}</h4>
                    <vue-editor
                      v-model="formValues.specification_text_de"
                      :editor-toolbar="customToolbar"
                    />
                    <h4 class="mt-3">{{ $t("Ausschreibungstext IT") }}</h4>
                    <vue-editor
                      v-model="formValues.specification_text_it"
                      :editor-toolbar="customToolbar"
                    />

                    <v-divider></v-divider>
                    <v-card-actions class="pl-0">
                      <v-btn
                        color="primary"
                        class="mr-4"
                        @click="$router.push({ name: 'item.index' })"
                      >
                        {{ $t("back") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" class="mr-4" @click="saveItem">
                        {{ $t("save") }}
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-tab-item>
              <v-tab-item key="links">
                <v-card class="px-2">
                  <h3>{{ $t("Doortypes") }}</h3>
                  <v-data-table
                    :headers="doorTypeHeaders"
                    :items="this.formValues.door_types"
                    :loading="loading"
                    :multi-sort="true"
                    class="elevation-1"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 50, -1]
                    }"
                  >
                    <template
                      v-slot:item.door_type_item_group.door_type.code="{ item }"
                    >
                      <a
                        @click="
                          $router.push({
                            name: 'doorType.edit',
                            params: {
                              id: item.door_type_item_group.door_type.id
                            }
                          })
                        "
                      >
                        {{ item.door_type_item_group.door_type.code }}</a
                      >
                    </template>
                  </v-data-table>

                  <h3 class="mt-5">{{ $t("Frames") }}</h3>
                  <v-data-table
                    :headers="frameHeaders"
                    :items="this.formValues.frames"
                    :loading="loading"
                    :multi-sort="true"
                    class="elevation-1"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 50, -1]
                    }"
                  >
                    <template v-slot:item.name="{ item }">
                      <a
                        @click="
                          $router.push({
                            name: 'frame.edit',
                            params: { id: item.id }
                          })
                        "
                      >
                        {{ item.name }}</a
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  fetchCategories,
  fetchItems,
  fetchSuppliers
} from "../shared/services";
import draggable from "vuedraggable";
import documentUpload from "../../shared/components/documents/document_upload";

export default {
  components: {
    draggable,
    documentUpload
  },
  name: "app-item-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2] }],
        ["bold", "italic", "underline"]
      ],
      formValues: {
        name: ""
      },
      items: [],
      categories: [],
      suppliers: [],
      loading: true,
      types: [
        {
          id: "general",
          name: "General"
        },
        {
          id: "glass",
          name: "Glass"
        },
        {
          id: "filling",
          name: "Filling"
        },
        {
          id: "wood",
          name: "Wood"
        },
        {
          id: "threshold",
          name: "Threshold"
        }
      ],
      system1: [
        {
          id: "EN179",
          name: "EN179"
        },
        {
          id: "EN1125",
          name: "EN1125"
        }
      ],
      tab: 0,
      doorTypeHeaders: [
        {
          text: "Code",
          align: "left",
          value: "door_type_item_group.door_type.code"
        },
        {
          text: "Name",
          align: "left",
          value: "door_type_item_group.door_type.name"
        }
      ],
      frameHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name"
        }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
    fetchCategories().then(res => {
      this.categories = res.data;
    });
    fetchItems().then(res => {
      this.items = res.data.filter(item => item.id != this.$route.params.id);
    });
    fetchSuppliers().then(res => {
      this.suppliers = res.data;
    });
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    sortSuppliers() {
      if (this.formValues.suppliers) {
        return this.formValues.suppliers.map(id => {
          return this.suppliers.find(supplier => supplier.id == id);
        });
      } else {
        return null;
      }
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "item.index" });
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.code.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    documentUploadCallback(document) {
      this.formValues.documents.push(document);
    },
    documentRemoveCallback(document) {
      this.formValues.documents = this.formValues.documents.filter(
        _document => _document.id != document.id
      );
    },
    removeSubitem(item) {
      this.formValues.subitems = this.formValues.subitems.filter(
        _item => _item.id != item.id
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
